import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Key, CreditCard } from 'lucide-react';

const PLANS = [
  { id: 'gratuito', label: 'Gratuito' },
  { id: 'premium', label: 'Premium' },
  { id: 'platinum', label: 'Platinum' },
  { id: 'black', label: 'Black' },
];

const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

export const ProfileDialogs = ({
  showKeyDialog, setShowKeyDialog, pendingPlan, accessKey, setAccessKey, activatingKey,
  onActivateKey, onStripeCheckout,
  showInfluencerWhatsApp, setShowInfluencerWhatsApp, influencerKeyValid,
  showWhatsAppGate, onSendWhatsAppGreeting, whatsAppSent, navigate
}) => (
  <>
    {/* Access Key Dialog */}
    <Dialog open={showKeyDialog} onOpenChange={setShowKeyDialog}>
      <DialogContent className="!bg-white max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-lg font-bold text-slate-900">Ativar Plano {PLANS.find(p => p.id === pendingPlan)?.label}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          <p className="text-sm text-slate-600">Digite a Chave de Acesso fornecida pelo <strong>INFLUENCIADOR</strong>:</p>
          <Input value={accessKey} onChange={e => setAccessKey(e.target.value.toUpperCase())}
            placeholder="Ex: INF-PRE-A1B2C3" className="font-mono text-center text-lg tracking-wider"
            data-testid="setup-access-key-input" />
          <div className="flex gap-2">
            <Button onClick={onActivateKey} disabled={activatingKey}
              className="flex-1 bg-slate-700 hover:bg-slate-800 text-white" data-testid="setup-activate-key-btn">
              <Key className="h-4 w-4 mr-2" />
              {activatingKey ? 'Ativando...' : 'Ativar com Chave'}
            </Button>
          </div>
          <div className="relative flex items-center gap-2">
            <div className="flex-1 h-px bg-slate-200"></div>
            <span className="text-xs text-slate-400">ou</span>
            <div className="flex-1 h-px bg-slate-200"></div>
          </div>
          <Button onClick={onStripeCheckout} disabled={activatingKey}
            className="w-full bg-amber-500 hover:bg-amber-600 text-white" data-testid="setup-stripe-btn">
            <CreditCard className="h-4 w-4 mr-2" />
            Pagar com Cartao
          </Button>
          <p className="text-xs text-slate-400 text-center">Pagamento mensal recorrente via Stripe</p>
        </div>
      </DialogContent>
    </Dialog>

    {/* Influencer WhatsApp Popup */}
    <Dialog open={showInfluencerWhatsApp && !influencerKeyValid} onOpenChange={setShowInfluencerWhatsApp}>
      <DialogContent className="!bg-white max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-lg font-bold text-slate-900">Chave de Convite</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          <p className="text-slate-600 text-sm">
            Para se cadastrar como Influenciador, voce precisa de uma Chave de Convite fornecida pelo administrador.
          </p>
          <Button
            onClick={() => {
              const msg = 'Ola! Gostaria de receber minha Chave de Convite para me tornar Influenciador no ClubdoCupom.';
              window.open(`https://wa.me/5517981124597?text=${encodeURIComponent(msg)}`, '_blank');
            }}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3"
            data-testid="request-invite-whatsapp-btn">
            <WhatsAppIcon className="h-5 w-5 mr-2" />
            Peca agora a Chave ao Administrador
          </Button>
          <p className="text-xs text-slate-400 text-center">Apos receber a chave, insira no campo acima para continuar o cadastro</p>
        </div>
      </DialogContent>
    </Dialog>

    {/* WhatsApp Gate - Free plan */}
    <Dialog open={showWhatsAppGate} onOpenChange={() => {}}>
      <DialogContent className="!bg-white max-w-md [&>button]:hidden" onPointerDownOutside={e => e.preventDefault()} onEscapeKeyDown={e => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-slate-900">Bem-vindo ao ClubdoCupom!</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          <p className="text-slate-600">Para ativar seu plano Gratuito, envie uma mensagem de saudacao pelo WhatsApp:</p>
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <p className="text-slate-800 font-medium italic">"Estou participando pelo plano Gratuito"</p>
          </div>
          <Button onClick={onSendWhatsAppGreeting}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3" data-testid="send-whatsapp-greeting-btn">
            <WhatsAppIcon className="h-5 w-5 mr-2" /> Enviar Saudacao no WhatsApp
          </Button>
          {whatsAppSent && (
            <Button onClick={() => navigate('/merchant')}
              className="w-full bg-amber-500 hover:bg-amber-600 text-white font-bold py-3" data-testid="proceed-to-dashboard-btn">
              Acessar Dashboard
            </Button>
          )}
          {!whatsAppSent && <p className="text-xs text-slate-400 text-center">Envie a mensagem para liberar o acesso</p>}
        </div>
      </DialogContent>
    </Dialog>
  </>
);
